<template>
  <div class="buy_container">
    <div class="step_progress">
      <div class="title">多仓直发 急速配达</div>
      <div class="progress_bar">
        <div class="progress_bar_item">
          <div class="line" :class="receivesList.length > 0 ? 'line_active' : ''"></div>
          <div class="num" :class="firstType ? 'num_active' : ''">1</div>
          <div class="text" :class="firstType ? 'text_active' : ''">选择平台</div>
        </div>
        <div class="progress_bar_item">
          <div class="line" :class="firstType && receivesList.length && goodInfo.uid ? 'line_active' : ''"></div>
          <div class="num" :class="firstType && receivesList.length > 0 ? 'num_active' : ''">2</div>
          <div class="text" :class="receivesList.length > 0 ? 'text_active' : ''">录入地址</div>
        </div>

        <div class="progress_bar_item">
          <div
            class="line"
            :class="firstType && receivesList.length > 0 && goodInfo.uid && orderSubmit ? 'line_active' : ''"
          ></div>
          <div class="num" :class="firstType && receivesList.length > 0 && goodInfo.uid ? 'num_active' : ''">3</div>
          <div class="text" :class="firstType && receivesList.length > 0 && goodInfo.uid ? 'text_active' : ''">
            选购礼品
          </div>
        </div>
        <div class="progress_bar_item">
          <div class="num" :class="orderSubmit ? 'num_active' : ''">4</div>
          <div class="text" :class="orderSubmit ? 'text_active' : ''">提交订单</div>
        </div>
      </div>
    </div>
    <div class="buy_body">
      <!-- <div class="wrapper" style="margin-bottom: 10px; color: #f99856">
        下单时请先对账号进行实名认证，未实名账号不允许下单，
        <a style="color: #1890ff" @click="$router.push({ path: '/vertify' })">点击跳转 </a>进入认证
      </div> -->
      <div class="step1 wrapper">
        <div class="title">选择数据来源平台</div>
        <ul class="type_list">
          <li
            v-for="item in platformTypeArr"
            :key="item.value"
            @click="handleFirstTypeSelected(item.value)"
            :class="firstType == item.value ? 'active' : ''"
          >
            {{ item.name }}
            <div class="image" v-show="firstType == item.value">
              <img src="@/assets/icon／选中.png" alt="" />
            </div>
          </li>
        </ul>
      </div>
      <div class="step2 wrapper">
        <div class="title_df">
          <div class="title2">录入收件地址</div>
          <div class="rechoose" @click="showNoSend" v-show="addressList.length > 0">查看快递停发区域</div>
        </div>
        <div class="input_address" @click="handleAddressInput" v-if="receivesList.length < 1">请输入收件人信息</div>
        <div v-else class="receives_list_container">
          <div class="receives_list">
            <div class="receives_list_item" v-for="item in receivesList" :key="item.id">
              <div class="left">
                <div class="top">
                  <div class="name">{{ item.name }}</div>
                  <div class="mobile" :class="item.virtual ? 'virtual_mobile' : ''">
                    {{ item.mobile }}
                  </div>
                  <div class="virtual_tip" v-show="item.virtual">虚拟号</div>
                </div>
                <div class="orderno">
                  {{ item.orderNo }}
                </div>
                <div class="address">
                  {{ item.province + item.city + item.county }}

                  {{ item.address }}
                </div>
              </div>
              <div class="rig">
                <img src="@/assets/icon／编辑.png" alt="" class="edit" @click="editReceives(item.id)" />
                <img src="@/assets/icon／删除.png" alt="" class="delete" @click="deleteReceives(item.id)" />
              </div>
            </div>
          </div>
          <div class="receivesList_desc">
            <span class="receivesList_num"> 已添加{{ receivesList.length }}个收件人 </span>
            <span>
              <span class="clear" @click="clearOrderData">清除数据</span>
            </span>
          </div>

          <div class="btn_wrapper">
            <van-button type="info" class="buy_btn" color="#f93244" round plain @click="handleAddressInput"
              >继续添加</van-button
            >
          </div>
          <div class="virtual_msg" v-show="virtualLength > 0">
            提示：以上信息存在虚拟手机号，拼多多官方规定虚拟手机号无法生成面单号，请联系买家索要真实手机号，点击右侧编辑修改！
          </div>
        </div>
      </div>
      <div class="step3 wrapper" v-if="!this.goodInfo.id">
        <div class="title">选购礼品</div>
        <div class="choose_goods" @click="handleChooseGood">+选购礼品</div>
      </div>

      <div class="step4 wrapper" v-else>
        <div class="title_df">
          <div class="title2">选购礼品</div>
          <div class="rechoose" @click="handleChooseGood">重新选择</div>
        </div>

        <div class="good_wrapper">
          <div class="left">
            <img :src="goodInfo.picture" alt="" />
          </div>
          <div class="rig">
            <div class="title">
              {{ goodInfo.name }}
            </div>
            <div class="desc">
              <div class="weight">{{ Number(goodInfo.weight) * 1000 }}g/件</div>
              <div class="site">
                {{ goodInfo.site }}
              </div>
            </div>
            <div class="price">
              <span>￥</span>
              <span class="money"> {{ goodInfo.price }}</span>
            </div>
          </div>
        </div>
        <div class="order_desc">
          <div class="order_desc_item">
            <div class="label">购买数量</div>
            <div class="value">1</div>
          </div>
          <div class="order_desc_item">
            <div class="label">配送方式</div>
            <div class="value">{{ goodInfo.deliveryName }}/{{ goodInfo.deliveryPrice }}元</div>
          </div>
          <div class="order_desc_item">
            <div class="label">订单备注</div>
            <input type="text" placeholder="选填，备注信息" class="input" v-model="comment" />
          </div>
          <div class="order_desc_total">
            <span> 共{{ receivesList.length }}个收件人 </span>
            <span class="total_label">
              运费:
              <span class="price">
                <span style="font-size: 2.133vw"> ￥ </span>

                {{ deliverySumPrice }}
              </span>
            </span>
            <span class="total_label">
              礼品:
              <span class="price">
                <span style="font-size: 2.133vw"> ￥ </span>
                {{ goodsSumPrice }}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div class="submit_bar">
        <div class="left">
          <span class="total"> 合计 </span>
          <div class="money">￥{{ giftSumPrice }}</div>
        </div>
        <div class="right">
          <van-button
            round
            type="info"
            style="width: 117px"
            color="#f93244"
            :disabled="!this.firstType || !this.goodInfo.uid || !this.receivesList.length > 0"
            @click="handleOrderSubmit"
            >提交订单</van-button
          >
        </div>
      </div>
    </div>
    <van-popup v-model="notSendShow" position="bottom" :style="{ height: '50%' }" closeable>
      <div class="not_send_title">快递停发区域</div>
      <van-tabs v-model="notSendActive" @change="notSendTabChange" :ellipsis="false" line-width="68px" ref="tabs">
        <van-tab
          :title="item.province + item.city.split('【')[0]"
          v-for="item in addressList"
          :key="item.uid"
          :name="item.uid"
        >
          <div class="not_send_list" v-if="notsendList.length > 0">
            <div v-for="notsend in notsendList" :key="notsend.id" class="not_send_list_item">
              {{ notsend.province + notsend.city + notsend.county }}
            </div>
          </div>
          <van-empty description="暂无停发区域" v-else />
        </van-tab>
      </van-tabs>
    </van-popup>
  </div>
</template>

<script>
import { platformType, jsonToArray } from "@/utils/util";
import Vue from "vue";
import { Dialog } from "vant";
import { premiumList, addressLogisticsListByUser, addressList, orderInsert } from "@/api";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      platformTypeArr: jsonToArray(platformType),
      firstType: "",
      goodInfo: {},
      notSendShow: false,
      notSendActive: "",
      addressList: [],
      notsendList: [],
      receivesList: [],
      orderSubmit: false,
      comment: "",
      noSend: [],
      virtualLength: 0,
    };
  },
  mounted() {
    //获取平台   /默认选淘宝
    if (Vue.ls.get("firstType")) {
      this.firstType = Vue.ls.get("firstType");
    } else {
      this.firstType = "TAOBAO";
      Vue.ls.set("firstType", "TAOBAO");
    }
    //获取收件人列表  /默认为空
    this.receivesList = Vue.ls.get("addressList") || [];

    this.validateMobile();
    //获取本地的礼品 /默认为空
    this.goodInfo = Vue.ls.get("goodInfo") || {};
    if (this.goodInfo.uid) {
      premiumList({ uid: this.goodInfo.uid }).then((res) => {
        if (res.data.length > 0) {
          this.noSend = res.data.filter((item) => {
            return item.send;
          });
        }
      });
    }
    //获取平台所有仓库
    this.getAddressList(this.firstType);
  },

  computed: {
    //快递总价
    deliverySumPrice() {
      const { goodInfo, receivesList } = this;
      const price = Number(goodInfo.deliveryPrice);
      const count = receivesList.length ? receivesList.length : 1;
      const result = price * count;

      if (isNaN(result)) {
        return null;
      }
      return result.toFixed(2);
    },
    //礼品价格
    goodsSumPrice() {
      const { goodInfo, receivesList } = this;
      const price = Number(goodInfo.price);
      const count = receivesList.length ? receivesList.length : 1;
      const result = price * count;
      if (isNaN(result)) {
        return null;
      }
      return result.toFixed(2);
    },
    //礼品总价
    giftSumPrice() {
      const result = Number(this.deliverySumPrice) + Number(this.goodsSumPrice);
      if (isNaN(result)) {
        return null;
      }
      return result.toFixed(2);
    },
  },

  methods: {
    ...mapGetters(["account", "userInfo"]),
    validateMobile() {
      this.virtualLength = 0;
      if (this.firstType == "PDD") {
        this.receivesList.forEach((item) => {
          if (/^1846694\d{4}$/.test(item.mobile)) {
            item.virtual = true;
          } else {
            item.virtual = false;
          }

          if (/^1846694\d{4}$/.test(item.mobile) || item.virtual) {
            this.virtualLength++;
          }
        });
      } else {
        this.receivesList.forEach((item) => {
          item.virtual = false;
        });
      }
    },
    handleFirstTypeSelected(type) {
      this.firstType = type;
      Vue.ls.set("firstType", type);
      //店铺清空
      let obj = Vue.ls.get("store");
      if (obj) {
        // obj.id = '';
        // obj.shopName = '';
        // obj.tag = '';
        Vue.ls.set("store", {});
      }
      //选购礼品清空
      if (this.goodInfo) {
        Vue.ls.set("goodInfo", {});
        this.goodInfo = Vue.ls.get("goodInfo");
      }
      this.getAddressList(type);
      this.validateMobile();
    },
    handleChooseGood() {
      if (this.addressList.length < 1) {
        return this.$toast.fail("该平台暂无礼品");
      }
      this.$router.push({
        path: "/goods",
        query: { type: this.firstType },
      });
    },
    getAddressList(type) {
      addressList(type).then((res) => {
        if (res.success) {
          this.addressList = res.data;
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    showNoSend() {
      this.notSendActive = "";
      this.notSendShow = true;
      this.$nextTick(() => {
        this.$refs.tabs.resize();
        this.notSendActive = this.addressList[0].uid;
        this.getpremiumList(this.notSendActive);
      });
    },
    getpremiumList(uid) {
      premiumList({ uid: uid }).then((res) => {
        if (res.success) {
          if (res.data.length > 0) {
            this.notsendList = res.data.filter((item) => {
              return item.send;
            });
          }
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    notSendTabChange(uid) {
      this.notSendActive = uid;
      this.getpremiumList(uid);
    },
    handleAddressInput() {
      this.$router.push("/address");
    },
    clearOrderData() {
      this.$dialog
        .confirm({
          title: "是否确认清除所有收货地址？",
        })
        .then(() => {
          Vue.ls.set("addressList", []);
          this.receivesList = Vue.ls.get("addressList");
        })
        .catch(() => {
          // on cancel
        });
    },
    deleteReceives(id) {
      const arr = Vue.ls.get("addressList");
      let newArr = arr.filter((item) => {
        return item.id !== id;
      });
      Vue.ls.set("addressList", newArr);
      this.receivesList = Vue.ls.get("addressList");
    },
    editReceives(id) {
      this.$router.push({ path: "/addressEdit", query: { id: id } });
    },
    // 检测是否实名验证过了
    async checkedVertify() {
      const user = this.userInfo();
      console.log("[user] ---> ", user);
      if (user.createTime < 1747206186000) return true;
      const accountInfo = this.account();
      console.log("[accountInfo] ---> ", accountInfo);
      const { hasCertify } = accountInfo;
      if (!hasCertify) {
        Dialog.confirm({
          message: "请进行实名认证后才能下单，是否立即前往认证?",
          confirmButtonText: "去认证",
        })
          .then(() => {
            this.$router.push('/vertify');
          })
          .catch((er) => {
            console.log("[er] ---> ", er);
          });
        return false;
      }
      return true;
    },
    async handleOrderSubmit() {
      // const checkedVertifyRes = await this.checkedVertify();
      // if (!checkedVertifyRes) return;
      const checkNoSend = {}; // 校验是否有拒绝发货的地址
      const { noSend } = this;
      this.orderSubmit = true;
      let { deliverySumPrice, goodsSumPrice, giftSumPrice, comment } = this;
      let obj = {
        deliverySumPrice,
        goodsSumPrice,
        giftSumPrice,
      };
      Vue.ls.set("totalPrice", obj);
      this.receivesList.forEach((item, index) => {
        //手机号
        item.mobile = item.mobile.replace("86-", ""); //检查停发
        noSend.map((item2) => {
          if (item.province && item2.province && item.province.indexOf(item2.province) > -1) {
            if (item.city && item2.city && item.city.indexOf(item2.city) > -1) {
              if (
                item.county.replace("县", "") &&
                item2.county.replace("县", "") &&
                item.county.replace("县", "").indexOf(item2.county.replace("县", "")) > -1
              ) {
                checkNoSend[index] = item;
              }
            }
          }
        });
      });
      const checkNoSendKey = [];
      for (const key in checkNoSend) {
        checkNoSendKey.push(parseInt(key) + 1);
      }
      if (checkNoSendKey.length > 0) {
        //提示
        const send = checkNoSend[checkNoSendKey[0] - 1];
        return this.$toast.fail(
          "第" +
            checkNoSendKey[0] +
            "条数据是 " +
            send.province +
            send.city +
            send.county +
            "，该地区已停发，请删除后再提交"
        );
      }

      const address = JSON.parse(JSON.stringify(this.receivesList));
      //拼多多修改虚拟单号
      if (this.firstType == "PDD") {
        address.forEach((item) => {
          if (item.virtual || /^1846694\d{4}$/.test(item.mobile)) {
            item.mobile = "13093856040";
          }
        });
      }
      let orderParams = {
        id: this.goodInfo.id,
        uid: this.goodInfo.uid,
        logisticsId: this.goodInfo.logisticsId,
        detailArray: address,
        comment: comment,
        platformType: this.firstType,
      };
      let store = Vue.ls.get("store");
      //店铺导入要带上店铺id
      if (Vue.ls.get("InsertWay") == "shop" && store) {
        orderParams.shopId = store.id;
        orderParams.shopName = store.shopName;
      }
      Vue.ls.set("orderParams", orderParams);
      //在这里提交订单
      orderInsert(orderParams).then((res) => {
        if (res.success) {
          this.$router.push({
            path: "/orderConfirm",
            query: {
              id: res.data.id,
            },
          });
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.buy_container {
  background: #f7f8fa;
  padding-bottom: 31vw;
}

.step_progress {
  background-color: #f7f8fa;
  background-image: url(~@/assets/xd_bg.png);
  background-size: cover;
  height: 35.524vw;
  padding-top: 5.067vw;
  padding-left: 3.2vw;
  margin-bottom: 3.2vw;
  .title {
    font-size: 6.4vw;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 4.667vw;
  }
  .progress_bar {
    width: 93.6vw;
    height: 19.467vw;
    background: #ffffff;
    border-radius: 2.133vw;
    display: flex;
    align-items: center;

    .progress_bar_item {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      position: relative;

      .line {
        width: 23.2vw;
        height: 0.533vw;
        background: #e5e5e5;
        position: absolute;
        top: 2.833vw;
        left: 10.133vw;
      }
      .line_active {
        background-color: #f93244;
      }
      .num {
        width: 5.333vw;
        height: 5.333vw;
        border-radius: 50%;
        background-color: #e5e5e5;

        color: #fff;
        font-size: 3.6vw;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 2.133vw;
        z-index: 2000;
      }
      .num_active {
        background-color: #f93244;
      }
      .text {
        font-size: 3.467vw;
        color: rgba(0, 0, 0, 0.45);
      }
      .text_active {
        color: rgba(0, 0, 0, 0.85);
      }
    }
  }
}
.buy_body {
  background: #f7f8fa;
  padding: 0 3.2vw;
}

.step1 {
  height: 44.533vw;
  margin-bottom: 3.2vw;
  .type_list {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 26.933vw;
      height: 12.8vw;
      text-align: center;
      line-height: 12.8vw;
      border: 1px solid rgba(0, 0, 0, 0.10196078431372549);
      border-radius: 1.067vw;
      margin-right: 3.2vw;
      margin-bottom: 3.2vw;
      font-size: 4vw;
      color: rgba(0, 0, 0, 0.85);
      position: relative;
      &:nth-child(3n) {
        margin-right: 0;
      }
      img {
        position: absolute;
        bottom: -1px;
        right: -1px;
        width: 4.985vw;
        height: 3.988vw;
      }
    }
    .active {
      border: 0.267vw solid #f93244;
    }
  }
}
.step2 {
  margin-bottom: 3.2vw;
  .input_address {
    font-size: 4vw;
    color: rgba(0, 0, 0, 0.45);
    padding: 3.2vw 3.2vw 3.2vw 0;
  }

  .receives_list_item {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 3.2vw 0;
    &:last-child {
      border-bottom: 0;
    }
    .left {
      .top {
        display: flex;
        align-items: center;
        font-size: 4vw;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 1.067vw;
        .name {
          margin-right: 3.2vw;
        }
        .virtual_mobile {
          color: #f93244;
        }
        .virtual_tip {
          margin-left: 1.6vw;
          color: #f93244;
          font-size: 3.2vw;
          padding: 0.533vw 2.133vw 0.533vw 2.133vw;
          background: #ffeaec;
          border-radius: 2.133vw;
        }
      }

      .orderno,
      .address {
        font-size: 3.467vw;
        color: rgba(0, 0, 0, 0.65);
        line-height: 4.533vw;
      }
    }

    .rig {
      display: flex;
      align-items: center;
      .edit,
      .delete {
        width: 6.4vw;
        height: 6.4vw;
      }
      .edit {
        margin-right: 3.2vw;
      }
    }
  }
  .receivesList_desc {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 3.2vw;
    font-size: 4vw;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.45);
  }

  .btn_wrapper {
    .buy_btn {
      width: 100%;
      height: 11.733vw;
      margin: 4.267vw 0 2.133vw;
    }
  }
  .virtual_msg {
    color: #f93244;
    font-size: 3.733vw;
    line-height: 1.2;
    margin-bottom: 2.133vw;
  }
}
.step3 {
  height: 40.8vw;

  .choose_goods {
    width: 87.2vw;
    height: 21.333vw;
    line-height: 21.333vw;
    text-align: center;
    background: #f7f8fa;
    border: 1px dashed rgba(0, 0, 0, 0.1);
    border-radius: 1.067vw;
    font-size: 3.467vw;
    color: rgba(0, 0, 0, 0.45);
  }
}
.title_df {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3.467vw;
  .title2 {
    font-size: 4vw;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }
  .rechoose {
    color: #f93244;
    font-size: 3.467vw;
  }
}
.step4 {
  .good_wrapper {
    display: flex;
    margin-bottom: 2.133vw;
    .left {
      width: 21.333vw;
      height: 21.333vw;
      border-radius: 1.067vw;
      margin-right: 2.133vw;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .rig {
      margin-top: 1.067vw;
      .title {
        font-size: 4vw;
        color: #333333;
        margin-bottom: 1.6vw;
        font-weight: 500;
      }
      .desc {
        color: #999999;
        margin-bottom: 5.333vw;
        display: flex;
        .weight {
          margin-right: 4.8vw;
          font-size: 3.2vw;
        }
        .site {
          font-size: 3.467vw;
        }
      }
      .price {
        font-family: Avenir-Heavy;
        font-weight: 550;
        color: #323233;
        .money {
          font-size: 4.533vw;
        }
      }
    }
  }
  .order_desc {
    .order_desc_item {
      display: flex;
      align-items: center;
      padding: 3.2vw 0;
      justify-content: space-between;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      font-size: 3.733vw;
      .input {
        margin-left: 3.2vw;
        border: none;
        flex: 1;
      }
    }
    .order_desc_total {
      text-align: right;
      font-size: 3.2vw;
      padding: 3.2vw 0 0;
      color: rgba(0, 0, 0, 0.45);
      .total_label {
        color: rgba(0, 0, 0, 0.65);
      }
      .price {
        color: #f93244;
      }
    }
  }
}
.wrapper {
  padding: 4.267vw 3.2vw 3.2vw;
  background: #ffffff;
  border-radius: 2.133vw;

  .title {
    font-size: 4vw;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 3.467vw;
  }
}
.submit_bar {
  height: 14.933vw;
  background-color: #fff;
  position: fixed;
  bottom: 12vw;
  left: 0;
  z-index: 100;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 3.733vw;
  padding-right: 4.267vw;
  .left {
    display: flex;
    align-items: center;
    .total {
      font-size: 3.2vw;
      color: rgba(0, 0, 0, 0.45);
      margin-right: 1.067vw;
    }
    .money {
      color: #f52907;
      font-size: 6.4vw;
      font-weight: 600;
    }
  }
}
.not_send_title {
  height: 10.933vw;
  line-height: 10.933vw;
  font-size: 4.533vw;
  padding-left: 4.267vw;
  color: rgba(0, 0, 0, 0.85);
}
.not_send_list {
  padding: 1.6vw 5.333vw;
  height: calc(50vh - 44px);
  overflow: auto;
  .not_send_list_item {
    padding: 3.2vw 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    &:last-child {
      border: 0;
    }
  }
}

// /deep/.van-tabs__line {
//   width: 68px;
// }
/deep/ .van-popup__close-icon--top-right {
  top: 9px;
}
</style>
